import { useQuery } from '@tanstack/react-query';
import { projectsAPI } from '../../services/api';
import { projectPageKeys } from '../../query/queryKeys';
import { useResolvedOrgId } from '../../hooks/useResolvedOrgId';

export function useProjectDetailOrgAndProject(streamId, projectId) {
  const { orgId, ready } = useResolvedOrgId();

  const projectQuery = useQuery({
    queryKey: projectPageKeys.detail(orgId, streamId, projectId),
    queryFn: () => projectsAPI.get(orgId, streamId, projectId),
    enabled: ready && !!orgId && !!streamId && !!projectId,
    staleTime: 30_000,
  });

  return {
    orgId,
    project: projectQuery.data ?? null,
    loading: !ready || projectQuery.isLoading,
    refetchProject: projectQuery.refetch,
  };
}
